import {Component} from 'react';
import h from 'react-hyperscript';
import {handleButtonKeyEvents} from 'Src/utils/utils';
import TabFocus from 'Components/TabFocus/TabFocus';
class TabHeader extends Component {
  constructor(props) {
    super(props);
    this.inactiveClasses = this.props.inactiveClasses;
    this.activeClasses = `${this.props.inactiveClasses} active`;
    this.state = {
      classes: this.inactiveClasses,
    };
  }

  componentDidMount() {
    this.checkClasses();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeTab !== prevProps.activeTab) {
      this.checkClasses();
    }
  }

  checkClasses() {
    if (Number(this.props.activeTab) === this.props.i) {
      this.setClasses(this.activeClasses);
    } else {
      this.setClasses(this.inactiveClasses);
    }
  }

  setClasses(value) {
    this.setState({
      classes: value,
    });
  }

  render() {
    const handleTabClick = this.props.handleTabClick;

    return (
      h(TabFocus, {
        key: `tab-${this.props.i}-title__key`,
        classes: this.state.classes,
        datatab: this.props.i,
        onClick: (e) => {
          handleTabClick(e);
        },
        onKeyUp: (e) => handleButtonKeyEvents(e, handleTabClick),
      },
      h('div', {
        tabIndex: -1,
      }, this.props.children)
      )
    );
  }
}

export default TabHeader;
